var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.07123 25.6334C4.31105 25.6334 3.66052 25.363 3.11964 24.8221C2.57877 24.2812 2.30787 23.6302 2.30694 22.8691V4.9013H0.924805V2.13702H7.83551V0.754883H16.1283V2.13702H23.039V4.9013H21.6569V22.8691C21.6569 23.6293 21.3865 24.2803 20.8456 24.8221C20.3047 25.3639 19.6537 25.6343 18.8926 25.6334H5.07123ZM18.8926 4.9013H5.07123V22.8691H18.8926V4.9013ZM7.83551 20.1048H10.5998V7.66558H7.83551V20.1048ZM13.3641 20.1048H16.1283V7.66558H13.3641V20.1048Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.b8af5dc029b2a232d25bb4f84990d44d.svg";
export { ForwardRef as ReactComponent };